<template>
  <div class="my-purchases">
    <div class="my-purchases-search hidden-xs-only">
      <el-input
        placeholder="Buscar">
        <i
          slot="prepend"
          class="icon-search-icon"/>
        <el-button
          slot="append">
          <i class="icon-sliders"/>
          Filtrar
        </el-button>
      </el-input>
    </div>
    <div>
      <mt-purchases
        v-for="(item) in 10"
        :key="item"/>
    </div>
  </div>
</template>

<script>
import mtPurchases from '../../components/_shared/mt-my-purchases-row'
export default {
  name: 'MyPurchases',
  components: {
    mtPurchases
  }
}
</script>

<style lang="scss" scoped>

.my-purchases-search{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user-profile/my_purchases.vue